import "../../styles/LandingSlider.css";
import Container from "react-bootstrap/Container";
import Card from "react-bootstrap/Card";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from "swiper";
import { useGetFeaturesQuery } from "../../redux/features/home/homeApiSlice";
// TODO: Delete all imgs below after add content to database.
import laptop from "../../assets/laptop.png";
import { BASE_URL } from "../../redux/api/apiSlice";

function LandingSlider() {
   // ################### RTK QUERY ###################
   const { data: features, isSuccess, isLoading } = useGetFeaturesQuery();

   // ################### CONTENT ###################
   let content;

   if (isSuccess && features?.data?.length > 0) {
      content = features?.data?.map((feature) => {
         return (
            <SwiperSlide key={feature?.Title}>
               <Card className={`cardComp ${feature?.id} `}>
                  <Card.Body>
                     <div className="card-icon">
                        <div className="circle-gradient"></div>
                        <div className="card-icon">
                           <img
                              src={`${BASE_URL}${feature?.Image}`}
                              alt="Feature-Icon"
                           />
                        </div>
                     </div>
                     <Card.Title style={{ fontSize: "18px" }}>
                        {feature?.Title}
                     </Card.Title>
                     <Card.Text className="card-text">
                        {feature?.Description}
                     </Card.Text>
                  </Card.Body>
               </Card>
            </SwiperSlide>
         );
      });
   } else if (!isLoading) {
      content = <p className="soon">سيتم إضافة البيانات قريبا.</p>;
   }

   return (
      <div className="landing" id="land-slider">
         <Container>
            <div className="slideContainer">
               <Swiper
                  breakpoints={{
                     640: {
                        slidesPerView: 2,
                        spaceBetween: 20,
                     },
                     768: {
                        slidesPerView: 3,
                        spaceBetween: 20,
                     },
                     1024: {
                        slidesPerView: 4,
                        spaceBetween: 20,
                     },
                  }}
                  modules={[Navigation, Pagination, Scrollbar, A11y, Autoplay]}
                  spaceBetween={50}
                  navigation
                  autoplay={true}
                  pagination={{ clickable: true }}
                  scrollbar={{ draggable: true }}
               >
                  {content}
                  {/* TODO: Remove all dummy code below after add content to database. */}
                  {/* <SwiperSlide>
                     <Card className="cardComp odd">
                        <Card.Body>
                           <div className="card-icon">
                              <div className="circle-gradient"></div>
                              <div className="card-icon">
                                 <img src={laptop} alt="laptop" />
                              </div>
                           </div>
                           <Card.Title style={{ fontSize: "18px" }}>
                              الاشكال المدروسة
                           </Card.Title>
                           <Card.Text className="card-text">
                              ألتابعة لشركة #MATREX المقدمة خصيصا تقدم
                              #منصة_التخليص_الجمركي للاستيراد والتصدير
                           </Card.Text>
                        </Card.Body>
                     </Card>
                  </SwiperSlide>
                  <SwiperSlide>
                     <Card className="cardComp even">
                        <Card.Body>
                           <div className="card-icon">
                              <div className="circle-gradient"></div>
                              <div className="card-icon">
                                 <img src={laptop} alt="clock" />
                              </div>
                           </div>
                           <Card.Title style={{ fontSize: "18px" }}>
                              الدعم الكامل
                           </Card.Title>
                           <Card.Text className="card-text">
                              ألتابعة لشركة #MATREX المقدمة خصيصا تقدم
                              #منصة_التخليص_الجمركي للاستيراد والتصدير
                           </Card.Text>
                        </Card.Body>
                     </Card>
                  </SwiperSlide>
                  <SwiperSlide>
                     <Card className="cardComp odd">
                        <Card.Body>
                           <div className="card-icon">
                              <div className="circle-gradient"></div>
                              <div className="card-icon">
                                 <img src={laptop} alt="promo" />
                              </div>
                           </div>
                           <Card.Title style={{ fontSize: "18px" }}>
                              افضل الاسعار
                           </Card.Title>
                           <Card.Text className="card-text">
                              ألتابعة لشركة #MATREX المقدمة خصيصا تقدم
                              #منصة_التخليص_الجمركي للاستيراد والتصدير
                           </Card.Text>
                        </Card.Body>
                     </Card>
                  </SwiperSlide>
                  <SwiperSlide>
                     <Card className="cardComp even">
                        <Card.Body>
                           <div className="card-icon">
                              <div className="circle-gradient"></div>
                              <div className="card-icon">
                                 <img src={laptop} alt="privacy" />
                              </div>
                           </div>
                           <Card.Title style={{ fontSize: "18px" }}>
                              السرية التامة
                           </Card.Title>
                           <Card.Text className="card-text">
                              ألتابعة لشركة #MATREX المقدمة خصيصا تقدم
                              #منصة_التخليص_الجمركي للاستيراد والتصدير
                           </Card.Text>
                        </Card.Body>
                     </Card>
                  </SwiperSlide>
                  <SwiperSlide>
                     {" "}
                     <Card className="cardComp odd">
                        <Card.Body>
                           <div className="card-icon">
                              <div className="circle-gradient"></div>
                              <div className="card-icon">
                                 <img src={laptop} alt="laptop" />
                              </div>
                           </div>
                           <Card.Title style={{ fontSize: "18px" }}>
                              الاشكال المدروسة
                           </Card.Title>
                           <Card.Text className="card-text">
                              ألتابعة لشركة #MATREX المقدمة خصيصا تقدم
                              #منصة_التخليص_الجمركي للاستيراد والتصدير
                           </Card.Text>
                        </Card.Body>
                     </Card>{" "}
                  </SwiperSlide>
                  <SwiperSlide>
                     {" "}
                     <Card className="cardComp even">
                        <Card.Body>
                           <div className="card-icon">
                              <div className="circle-gradient"></div>
                              <div className="card-icon">
                                 <img src={laptop} alt="laptop" />
                              </div>
                           </div>
                           <Card.Title style={{ fontSize: "18px" }}>
                              الاشكال المدروسة
                           </Card.Title>
                           <Card.Text className="card-text">
                              ألتابعة لشركة #MATREX المقدمة خصيصا تقدم
                              #منصة_التخليص_الجمركي للاستيراد والتصدير
                           </Card.Text>
                        </Card.Body>
                     </Card>{" "}
                  </SwiperSlide> */}
                  <br />
                  <br />
               </Swiper>
            </div>
         </Container>
      </div>
   );
}

export default LandingSlider;
